import(/* webpackMode: "eager", webpackExports: ["useNotificationProvider"] */ "/app/refine/node_modules/@refinedev/chakra-ui/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Refine"] */ "/app/refine/node_modules/@refinedev/core/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["DevtoolsProvider"] */ "/app/refine/node_modules/@refinedev/devtools/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["RefineKbarProvider","RefineKbar"] */ "/app/refine/node_modules/@refinedev/kbar/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/refine/node_modules/@refinedev/nextjs-router/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/refine/node_modules/next/font/google/target.css?{\"path\":\"src/utils/font.ts\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/refine/node_modules/next/font/google/target.css?{\"path\":\"src/utils/font.ts\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-manrope\"}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager" */ "/app/refine/node_modules/next/font/google/target.css?{\"path\":\"src/utils/font.ts\",\"import\":\"IBM_Plex_Mono\",\"arguments\":[{\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"variable\":\"--ibm-plex-mono\"}],\"variableName\":\"ibmPlexMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/refine/src/components/analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomUIProvider"] */ "/app/refine/src/components/custom-ui-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["accessControlProvider"] */ "/app/refine/src/providers/access-control-provider/index.ts");
;
import(/* webpackMode: "eager" */ "/app/refine/src/providers/auth-provider/auth-provider.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ChakraProvider"] */ "/app/refine/src/providers/chakra-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["servicesProvider"] */ "/app/refine/src/providers/data-provider/index.ts");
;
import(/* webpackMode: "eager" */ "/app/refine/src/styles/global.scss");
